export default {
  regionalRiskAssessment: {
    eudrDueDiligence: "Uhakiki wa Uangalifu wa EUDR",
    title: "Tathmini ya Hatari ya Kanda",
    titleTT: "Upimaji wa nchi katika tathmini ya hatari ya kikanda ya EUDR",
    details: "Maelezo",
    detailsTT: "Panua ili kuona vigezo vya kina na marejeleo yanayohusiana na uainishaji wa hatari kubwa, ukizingatia ukataji miti, haki za wenyeji, ufisadi, na masuala ya haki za binadamu.",
    createNewCountryReport: "Unda Ripoti Mpya ya Nchi",
    updateCountryReport: "Sasisha Ripoti ya Nchi",
    duplicateCountryReport: "Nakili Ripoti ya Nchi",
    search: "Tafuta",
    country: "Nchi",
    dateCreated: "Tarehe Iliyoumbwa",
    edit: "Hariri",
    delete: "Futa",
    duplicate: "Nakili",
    actions: "Vitendo",
    submit: "Tuma",
    save: "Hifadhi",
    cancel: "Ghairi",
    selectCountry: "Chagua Nchi",
    riskAssessmentCriteria: "Vigezo vya Tathmini ya Hatari",
    riskLevel: "Kiwango cha Hatari",
    unassigned: "Haijapewa",
    standard: "Kawaida",
    standardToHigh: "Kawaida hadi Juu",
    high: "Juu",
    reportDetails: "Maelezo ya Ripoti",
    select: "Chagua",
    requiredFields: "Sehemu hii ni lazima",
    pleaseFillRequiredFields: "Tafadhali jaza sehemu zote zinazohitajika",
    createCuccess: "Tathmini ya hatari ya kanda imeundwa kwa mafanikio",
    updateSuccess: "Tathmini ya hatari ya kanda imesasishwa kwa mafanikio",
    createError: "Hitilafu katika kuunda tathmini ya hatari ya kanda",
    updateError: "Hitilafu katika kusasisha tathmini ya hatari ya kanda",
    deleteSuccess: "Tathmini ya hatari ya kanda imefutwa kwa mafanikio",
    duplicateSuccess: "Tathmini ya hatari ya kanda imenakiliwa kwa mafanikio",
    deleteRegionalRisk: "Futa Tathmini ya Hatari ya Kanda",
    confirmDelete: "Je, una uhakika unataka kufuta tathmini hii ya hatari ya kanda?",
    confirm: "Thibitisha",
    saveSuccess: "Tathmini ya hatari ya kanda imehifadhiwa kwa mafanikio",
    fetchError: "Hitilafu katika kupata tathmini ya hatari ya kanda",
    disregard: "Puuza Sehemu",
    addRegionalRiskAssessment: "Ongeza Tathmini ya Hatari ya Kanda",
    summary: "Muhtasari",
    summaryTT: "Sehemu hii inaelezea viwango vya hatari vilivyotolewa kulingana na data na marejeleo ya kina.",
    summaryText: "Tathmini ya hatari ya nchi itaiainisha nchi ya shamba kulingana na viwango vifuatavyo vya hatari (Juu, Kawaida, na Zero/Haitishi) kulingana na marejeo yanayoweza kuthibitishwa, taarifa, nyaraka, na data. Matokeo tofauti na 'Zero/Haitishi' yataonyesha hitaji la hatua ya kupunguza hatari (AMR) ili kuhakikisha 'Hatari Zero/Haitishi'. Jedwali 1 linaonyesha matokeo jumla ya tathmini ya hatari kwa (country). Tathmini kamili ya hatari ya nchi imeambatanishwa na hati hii kwenye Kiambatisho III.",
    disregardConfirmTitle: "Puuza Sehemu Yoyote au Zote",
    selectSegment: "Chagua sehemu za kupuuza.",
    addConfirmTitle: "Ongeza Sehemu Yoyote au Zote",
    deselectToAddSegment: "Batilisha uteuzi wa sehemu kuongeza.",
    all: "Zote",
    protectedAreas: "Maeneo Yaliyohifadhiwa na ya Asili",
    verificaton: "Uthibitisho na Hifadhidata ya Serikali ya Brazil",
    confirmation: "Uthibitisho",
    confirmationMessage: "Je, uko na uhakika unataka kupuuza tathmini ya hatari ya kanda? Kuthibitisha hatua hii kutasababisha kuondolewa kwa tathmini ya hatari ya kanda kutoka kwa ripoti ya uangalizi wa kina.",
    noSegmentSelectedMessage: "Hakuna sehemu iliyochaguliwa. Tafadhali chagua sehemu ili kuendelea.",
    singleRiskAssessmentCriteriaMessage: "Je, una uhakika unataka kuongeza au kuondoa Vigezo vya Tathmini ya Hatari ya Kikanda? Kuthibitisha hatua hii kutasasisha ripoti ya uchunguzi wa kina.",
    singleProtectedAreasMessage: "Je, una uhakika unataka kuongeza au kuondoa Maeneo Yaliyohifadhiwa na ya Asili? Kuthibitisha hatua hii kutasasisha ripoti ya uchunguzi wa kina.",
    bothSegmentsMessage: "Je, una uhakika unataka kuongeza au kuondoa Vigezo vya Tathmini ya Hatari ya Kikanda na Maeneo Yaliyohifadhiwa na ya Asili? Kuthibitisha hatua hii kutasasisha ripoti ya uchunguzi wa kina.",
    segmentsUpdatedSuccessfully: "Sehemu zimeboreshwa kwa mafanikio"
  }
}
